// TODO: Actions sub folders

import {
  ADD_PARTICIPATION,
  DELETE_DISCUSSION,
  EDIT_ACTIVITY_IN_COURSE_STATE,
  END_LIVE_DISCUSSION,
  LD_GIVE_POINT,
  LD_REMOVE_POINT,
  LOADING_LIVE_DISCUSSION,
  /*   NEW_TURN, */
  PAUSE_LIVE_DISCUSSION,
  POST_CLASS_SUMMARY_LD,
  POST_DRAFT_FEEDBACK_FOR_STUDENT,
  POST_FEEDBACK_FOR_STUDENT,
  UPDATE_FEEDBACK_FOR_STUDENT_LD,
  POST_PARTICIPATION_SUMMARY,
  PUBLISH_LD_IN_COURSE_STATE,
  PUBLISH_LIVE_DISCUSSION,
  REMOVE_STUDENT_LD,
  REMOVE_STUDENTS_LD,
  RESTART_LIVE_DISCUSSION,
  START_LIVE_DISCUSSION,
  UPDATE_HAND_RAISES,
  UPDATE_LIVE_DISCUSSION,
  UPDATE_PARTICIPATION,
  UPDATE_PARTICIPATION_SPREAD,
  UPDATE_POINTS_SETTINGS_LIVE_DISCUSSION,
  UPDATE_PRIVATE_TEACHER_NOTES_LD,
  UPDATE_STUDENT_NOTES_LD,
  UPDATE_TURN,
  SOCKET_UPDATE_QUEUE,
  UPDATE_NUDGES,
  UPDATE_LIVE_DISCUSSION_CIRCLE,
  UPDATE_PARTICIPATION_TURN_COUNT,
  UPDATE_LIVE_DISCUSSION_SPREAD,
  UPDATE_DRAFT_STUDENT_ASSESSMENTS,
  UPDATE_STUDENT_ASSESSMENTS,
  LOADING_GRADES,
  MARK_LIVE_DISCUSSION_AS_PUBLISHED,
  UPDATE_STUDENT_POINT_SETTINGS,
  TEACHER_TAP_IN,
  TEACHER_TAP_OUT,
  VIDEO_OFF_MUTE_PARTICIPATIONS,
  MUTE_PARTICIPATIONS,
  UPDATE_LD_DETAILS,
  MARK_ROUNDTABLE_AS_OPENED,
  UPDATE_TURNS_POSITION,
  UPDATE_STUDENT_NUDGE,
  UPDATE_SPEAKER_COUNT,
  ADD_ACTIVITY_PASSES,
} from 'store/mutation-types';

import find from 'lodash/find';
import { cloneDeep, sortBy } from 'lodash';
import { EventBus } from 'utils/event-bus';
import liveDiscussionService from 'services/liveDiscussion';
import raiseHandService from 'services/liveDiscussion/raiseHand';
import removePointService from 'services/liveDiscussion/removePoint';
import studentSummaryService from 'services/liveDiscussion/studentSummaryLD';
import moderatorChosenService from 'services/liveDiscussion/moderatorChosen';
import resetModeratorService from 'services/liveDiscussion/resetModerator';
import toggleQueueService from 'services/liveDiscussion/toggleQueue';
import updateParticipantAssessment from 'services/liveDiscussion/updateParticipantAssessment';
import updateDraftParticipantAssessment from 'services/liveDiscussion/updateDraftParticipantAssessment';
import { getLiveDiscussionCircle } from 'services/liveDiscussion/circle/circleServices.js';
import toggleDiscussionAudio from 'services/liveDiscussion/toggleDiscussionAudio.js';
import endAudioConnection from '../../services/liveDiscussion/endAudioConnection';

// QUEUE ENDPOINTS - TODO: GET FROM AN INDEX
import autoTurnSpeakerService from 'services/liveDiscussion/queue/autoTurnSpeaker';
import enterQueueService from 'services/liveDiscussion/queue/enterQueue';
import leaveQueueService from 'services/liveDiscussion/queue/leaveQueue';
import tapOutService from 'services/liveDiscussion/queue/tapOut';
import tapInService from 'services/liveDiscussion/queue/tapIn';
import notSpeakOfQueueService from 'services/liveDiscussion/queue/notSpeakOfQueue';
import promoteStudentService from 'services/liveDiscussion/queue/promoteStudent';
import turnOffQueueService from 'services/liveDiscussion/queue/turnOffQueue';

import Vue from 'vue';
import {
  DELETE_RECENT_RT,
  UPDATE_PARTICIPATION_SUMMARY,
} from '../mutation-types';
import Axios from 'axios';

// TODO: Revisit / Refactor
// Action fires when a the discussion route is hit
const fetchLiveDiscussion = async ({ commit }, discussionID) => {
  try {
    commit(LOADING_LIVE_DISCUSSION, true);
    const transcription = await Axios.get(`/api/transcriptions/${discussionID}/transcription`);
    
    const { data: genieData } = await Axios.get(`/api/verbal_recaps/verbal_discussion/${discussionID}`);
    const transcription_data = transcription.data.data;
    const { data } = await liveDiscussionService.loadLiveDiscussion(discussionID);
    if (transcription) {
      data.transcriptions = transcription_data;
    }
    
    if (genieData.id) {
      data.genie_recap = genieData;
    }
    const discussion = data;
    commit(UPDATE_LIVE_DISCUSSION, discussion);
    commit(LOADING_LIVE_DISCUSSION, false);
    return discussion;

  } catch (error) {
    commit(LOADING_LIVE_DISCUSSION, false);
    console.error(error);
  }
};

// TODO: Rafactor
const inviteStudentsToLD = (
  { dispatch, getters, commit },
  { live_discussion_id, student_ids }
) => {
  return liveDiscussionService
    .forceJoinStudents(live_discussion_id, student_ids)
    .then((res) => {
      const participations = res.data.map((participation) => {
        // put user info into participation
        const user = find(getters.getStudentsInCourse, {
          id: participation.user_id || participation.UserId,
        });
        participation.user = user || { name: 'unknown' };
        return participation;
      });
      participations.forEach((participation) => {
        commit(ADD_PARTICIPATION, participation);
      });
      dispatch(
        'analytics',
        'create written roundtable - add students via add student list'
      );
      dispatch('fetchLiveDiscussion', live_discussion_id);
    })
    .catch(console.error);
};

// TODO: Revisit / Refactor
const enterLiveDiscussion = ({ dispatch }, { liveDiscussionID }) => {
  dispatch(
    'analytics',
    'student verbal discussion - access verbal discussion',
    {
      routeFrom: 'course page',
    }
  );
  return dispatch('fetchLiveDiscussion', liveDiscussionID);
};

const givePoint = ({ commit }, { tag, participation_id }) => {
  liveDiscussionService
    .givePoint(participation_id, { tag })
    // TODO: Update the state mutation
    .then((res) => commit(LD_GIVE_POINT, res.data));
};

const removePoint = ({ commit }, { tag, participation_id }) => {
  removePointService(participation_id, { tag })
    // TODO: Update the state mutation
    .then((res) => commit(LD_REMOVE_POINT, res.data));
};

const updateTurn = ({ commit }, turn) => {
  commit(UPDATE_TURN, turn);
};

const updateLiveDiscussion = ({ commit }, discussion) => {
  commit(UPDATE_LIVE_DISCUSSION, discussion);
};

const saveLiveDiscussionSettings = ({ commit }, payload) => {
  return liveDiscussionService
    .saveLiveDiscussion(payload.id, payload)
    .then(({ data }) => {
      commit(UPDATE_LD_DETAILS, data);
      EventBus.$emit('toast-msg', 'Successfully saved Discussion Settings!');
      commit(EDIT_ACTIVITY_IN_COURSE_STATE, data);
      return null;
    })
    .catch(() => { });
};

const updateStudentPointSettings = ({ commit }, payload) => {
  commit(UPDATE_STUDENT_POINT_SETTINGS, payload);
};

const publishLiveDiscussion = ({ commit }, id) => {
  commit(PUBLISH_LIVE_DISCUSSION, true);
  commit(PUBLISH_LD_IN_COURSE_STATE, id);
};

const SOCKET_setStartLiveDiscussion = ({ commit }, discussion) => {
  commit(EDIT_ACTIVITY_IN_COURSE_STATE, discussion);
  commit(START_LIVE_DISCUSSION, discussion.discussion_start_time);
  EventBus.$emit('statusDiscussionChange');
};

// Only a teacher can dispatch this action
const pauseLiveDiscussion = (context, { liveID, status }) => {
  liveDiscussionService.togglePause(liveID, status);
};

const setDiscussionPauseStatus = ({ commit }, payload) => {
  commit(PAUSE_LIVE_DISCUSSION, payload);
};

const getDiscussionTurns = ({ commit }, payload) => {
  commit(UPDATE_TURNS_POSITION, payload);
};


const getNewAddTurn = ({ commit, getters }, payload) => {
  const clone_turns_circle = cloneDeep(getters.getCurrentDiscussion.turns_in_circle);
  clone_turns_circle.push(payload.turn_participation);
  if (getters.getCurrentDiscussion.audio_discussion_is_enabled) {
    EventBus.$emit('check-user-local-camera', payload.turn_participation.participation_id);
  }
  return commit(UPDATE_LIVE_DISCUSSION_CIRCLE, clone_turns_circle);
};
const removeTurn = ({ commit, getters }, payload) => {
  const clone_turns_circle = cloneDeep(getters.getCurrentDiscussion.turns_in_circle);
  const index_to_remove = clone_turns_circle.findIndex((turn) => turn.id === payload.turn_to_remove.id);
  if (index_to_remove > -1) {
    const turn = clone_turns_circle.find((turn) => turn.id === payload.turn_to_remove.id);
    const current_speaker = getters.getCurrentDiscussion.currently_active;
    if (current_speaker === turn.participation.user.id) {
      const payload = {
        id: getters.getCurrentDiscussion.id,
        queue: [],
        currently_active: null,
      };
      commit(SOCKET_UPDATE_QUEUE, payload);
    }
    clone_turns_circle.splice(index_to_remove, 1);
  }
  return commit(UPDATE_LIVE_DISCUSSION_CIRCLE, clone_turns_circle);
};
const addTurnQueue = ({ commit, getters }, payload) => {
  const clone_turns_circle = cloneDeep(getters.getCurrentDiscussion.turns_in_circle);
  const index = clone_turns_circle.findIndex(item => item.id === payload.turn_participation.id);
  clone_turns_circle.splice(index, 1, payload.turn_participation);
  return commit(UPDATE_LIVE_DISCUSSION_CIRCLE, clone_turns_circle.sort((x, y) => x.queue_position - y.queue_position));
};
const removeTurnQueue = ({ commit, getters }, payload) => {
  const clone_turns_circle = cloneDeep(getters.getCurrentDiscussion.turns_in_circle);
  const index = clone_turns_circle.findIndex(item => item.id === payload.turn_participation.id);
  clone_turns_circle.splice(index, 1);
  const new_turns_in_circle = clone_turns_circle.concat(payload.turn_participation);
  return commit(UPDATE_LIVE_DISCUSSION_CIRCLE, sortBy(new_turns_in_circle, ['queue_position', 'created_at'], ['asc', 'asc']));
};
const setTurnSpeaker = ({ commit, getters }, payload) => {
  const clone_turns_circle = cloneDeep(getters.getCurrentDiscussion.turns_in_circle);
  const index = clone_turns_circle.findIndex(item => item.id === payload.turn_participation.id);
  clone_turns_circle.splice(index, 1);
  const new_turns_in_circle = clone_turns_circle.concat(payload.turn_participation);
  commit(UPDATE_SPEAKER_COUNT, payload.turn_participation);
  commit(UPDATE_PARTICIPATION_SUMMARY, { currently_active: payload.turn_participation.participation.user.id });
  return commit(UPDATE_LIVE_DISCUSSION_CIRCLE, new_turns_in_circle.sort((x, y) => x.queue_position - y.queue_position));
};
const removeTurnSpeaker = ({ commit, getters }, payload) => {
  const clone_turns_circle = cloneDeep(getters.getCurrentDiscussion.turns_in_circle);
  const current_speaker_turn = clone_turns_circle[0].id;
  if (current_speaker_turn === payload.turn_participation.id) {
    clone_turns_circle.shift();
    return commit(UPDATE_LIVE_DISCUSSION_CIRCLE, clone_turns_circle.sort((x, y) => x.queue_position - y.queue_position));
  }
};
// Only Teacher has the right to dispatch this action
const endLiveDiscussion = ({ commit }, liveID) => {
  liveDiscussionService
    .end(liveID)
    .then((res) => {
      commit(END_LIVE_DISCUSSION, res.data);
    })
    .catch(console.error);
};

const restartLiveDiscussion = ({ commit }, liveID) => {
  return liveDiscussionService
    .restart(liveID)
    .then((res) => {
      commit(RESTART_LIVE_DISCUSSION, res.data);
      return res.data;
    })
    .catch(console.error);
};

// NOTE: state updated through socket
const startLiveDiscussion = ({ dispatch }, discussion_id) => {
  dispatch(
    'analytics',
    'teacher moderate verbal discussion - start verbal discussion'
  );
  return liveDiscussionService
    .startLiveDiscussion(discussion_id)
    .catch(console.error);
};

const setLDHasEnded = ({ commit, getters }, discussion) => {
  commit(EDIT_ACTIVITY_IN_COURSE_STATE, discussion);
  commit(END_LIVE_DISCUSSION, discussion);
  if (!getters.isLiveDiscussionBetaTester) {
    Vue.router.replace({
      name: 'live.measure',
      params: {
        liveDiscussionID: discussion.id,
      },
    });
  }
};

const setLDHasRestarted = ({ commit }, discussion) => {
  commit(EDIT_ACTIVITY_IN_COURSE_STATE, discussion);
  commit(RESTART_LIVE_DISCUSSION, discussion);

  EventBus.$emit('statusDiscussionChange');
};

const addParticipation = ({ commit }, payload) => {
  commit(ADD_PARTICIPATION, payload);
  commit(MARK_LIVE_DISCUSSION_AS_PUBLISHED, payload.live_discussion_id);
};

const updateParticipation = ({ commit }, payload) => {
  commit(UPDATE_PARTICIPATION, payload);
};
const updateParticipationSpread = ({ commit }, payload) => {
  commit(UPDATE_PARTICIPATION_SPREAD, payload);
};

const newTurn = ({ commit }, payload) => {
  /* commit(NEW_TURN, payload); */
  commit(UPDATE_PARTICIPATION_SUMMARY, payload);
  EventBus.$emit(
    'queue-select-student-for-assessment-if-necessary',
    payload.currently_active
  );
};

const fetchParticipationSummary = ({ commit }, participation_id) => {
  commit(LOADING_GRADES, true);
  return studentSummaryService(participation_id).then((res) => {
    commit(POST_PARTICIPATION_SUMMARY, res.data);
    commit(LOADING_GRADES, false);
    return res.data;
  });
};

const postClassSummaryLD = ({ commit }, payload) => {
  commit(POST_CLASS_SUMMARY_LD, payload);
};

// Activate loading spinner
const loadingLiveDiscussion = ({ commit }, status) => {
  commit(LOADING_LIVE_DISCUSSION, status);
};

const deleteDiscussion = async ({ commit, getters }, payload) => {
  try {
    await liveDiscussionService.deleteDiscussion(payload.id);
    commit(DELETE_DISCUSSION, payload.id);
    commit(DELETE_RECENT_RT, payload.id);


    if (payload.rtPage) {
      Vue.router.push({ name: 'course.index' });
    }

    if (getters.getProfile.is_paid === false && getters.getProfile.activity_passes < 6) {
      commit(ADD_ACTIVITY_PASSES, 1);
    }

    EventBus.$emit('createToast',{ type: "Success", message: "Discussion was successfully deleted!", time: 5000 });

  } catch (error) {
    EventBus.$emit('createToast',{ type: "Error", message: "Discussion was not successfully deleted, please try again.", time: 5000 });
    console.error(error);
  }
};

const removeStudentLD = (
  { commit, dispatch },
  { live_discussion_id, user_id }
) => {
  liveDiscussionService
    .removeStudent(live_discussion_id, user_id)
    .then(() => commit(REMOVE_STUDENT_LD, user_id))
    .catch(console.error);
  dispatch('fetchLiveDiscussion', live_discussion_id);
};

const removeStudentsLD = (
  { commit, dispatch },
  { student_ids, live_discussion_id }
) => {
  return liveDiscussionService
    .removeStudents(live_discussion_id, { student_ids })
    .then((res) => {
      commit(REMOVE_STUDENTS_LD, res.data);
      dispatch('fetchLiveDiscussion', live_discussion_id);
      return res;
    })
    .catch(console.error);
};

const postFeedbackForStudent = ({ commit }, payload) => {
  commit(POST_FEEDBACK_FOR_STUDENT, payload);
};

const updateFeedbackForStudentLD = ({ commit }, payload) => {
  commit(UPDATE_FEEDBACK_FOR_STUDENT_LD, payload);
};

const updatePointsSettingsLiveDiscussion = ({ commit }, payload) => {
  commit(UPDATE_POINTS_SETTINGS_LIVE_DISCUSSION, payload);
};

// NOTE: Only for students
const raiseHand = ({ commit }, participation_id) => {
  raiseHandService(participation_id).then(({ data }) => {
    const participation = data;
    commit(UPDATE_HAND_RAISES, participation);
  });
};

const updateStudentNotesLD = ({ commit }, notesContent) => {
  commit(UPDATE_STUDENT_NOTES_LD, notesContent);
};

const updatePrivateTeacherNotes = ({ commit }, observations) => {
  commit(UPDATE_PRIVATE_TEACHER_NOTES_LD, observations);
};

const SOCKET_updateQueue = ({ commit, getters }, payload) => {
  let type = '';
  getters.getCurrentDiscussion.currently_active === null ||
    getters.getCurrentDiscussion.currently_active !== payload.currently_active
    ? (type = 'speaker')
    : (type = 'not-speaker');
  commit(SOCKET_UPDATE_QUEUE, payload);
  if (getters.getProfile.id === payload.currently_active) {
    if (type === 'speaker') {
      EventBus.$emit('currently_speaker');
    }
  }
};

const nudgeStudent = ({ commit }, { participation_id, message }) => {
  return liveDiscussionService
    .nudge(participation_id, message)
    .then((res) => {
      EventBus.$emit('toast-msg', 'Nudge Sent!');
      commit(UPDATE_NUDGES, {
        id: participation_id,
        nudges: res.data,
      });
      return null;
    })
    .catch(console.error);
};

const publishStudentNotes = (options, participation_id) => {
  liveDiscussionService
    .publishStudentNotes(participation_id)
    .then(() => {
      // update notes_array with new published state
      EventBus.$emit('toast-msg', 'Success!');
      return null;
    })
    .catch(console.error);
};

// Queue Actions: State updated through sockets
// TODO: Promote Student
// TODO: Put queue actions in a different file
// TODO: analytics
const autoTurnSpeaker = (
  options,
  { discussion_id, hand_raise_type }
) => {
  return autoTurnSpeakerService(discussion_id, hand_raise_type)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      return { error };
    });
};
const enterQueue = (
  options,
  { discussion_id, hand_raise_type, user_id, turn_id }
) => {
  return enterQueueService(discussion_id, hand_raise_type, user_id, turn_id)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      return { error };
    });
};

const leaveQueue = async (options, { discussion_id, user_id, turn_id }) => {
  return leaveQueueService(discussion_id, user_id, turn_id)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      return { error };
    });
};

const tapOut = async (options, { discussion_id, user_id }) => {
  return tapOutService(discussion_id, user_id).then(({ data }) => data).catch((error) => {
      console.error(error);
      return { error };
    });
};
const tapIn = (options, { discussion_id, turn_type }) => {
  return tapInService(discussion_id, turn_type).catch(console.error);
};

const notSpeakOfQueue = (options, { discussion_id, user_id }) => {
  notSpeakOfQueueService(discussion_id, user_id).catch(console.error);
};

const promoteStudent = (
  options,
  { discussion_id, student_to_promote, user_id }
) => {
  promoteStudentService(discussion_id, student_to_promote, user_id).catch(
    console.error
  );
};

const turnOffQueue = (options, discussion_id) => {
  turnOffQueueService(discussion_id).catch(console.error);
};


const submitDraftFeedbackForStudent = ({ commit }, payload) => {
  const { participation_id, feedback_content } = payload;
  delete payload.participation_id;

  return liveDiscussionService
    .addDraftFeedbackForStudent(participation_id, {
      draft_feedback_for_student: feedback_content,
    }).then(() => {
      commit(POST_DRAFT_FEEDBACK_FOR_STUDENT, feedback_content);
    }).catch((err) => console.error(err));
};
const submitFeedbackForStudent = ({ dispatch }, payload) => {
  const { participation_id, feedback_content, auto_save } = payload;
  delete payload.participation_id;
  dispatch(
    'analytics',
    'teacher student reports - submit student feedback'
    // { isOngoing: !this.getCurrentDiscussion.is_ended }
  );
  return liveDiscussionService
    .addFeedbackForStudent(participation_id, {
      feedback_for_student: [feedback_content],
      auto_save,
    })
    .then((res) => {
      dispatch('postFeedbackForStudent', res.data.feedback_for_student);
      if (!auto_save) {
        EventBus.$emit(
          'toast-msg',
          'Your feedback has successfully been sent!'
        );
        dispatch('updateFeedbackForStudentLD', {
          id: participation_id,
          feedback: res.data.feedback_for_student,
        });
      }
      return null;
    })
    .catch((err) => {
      console.error(err);
      const msg = 'Whoops something went wrong. Try submitting feedback again.';
      EventBus.$emit('toast-msg', msg);
    });
};

const updateDraftAssessment = ({ commit }, data) => {
  return updateDraftParticipantAssessment(data.participationID, data.payload).then(
    (res) => {
      commit(UPDATE_DRAFT_STUDENT_ASSESSMENTS, res.data.draft_assessments);
    }
  );
};

const updateAssessment = ({ commit }, data) => {
  return updateParticipantAssessment(data.participationID, data.payload).then(
    (res) => {
      commit(UPDATE_STUDENT_ASSESSMENTS, res.data.assessments);
    }
  );
};

const SOCKET_ReceiveNudge = ({ commit, getters }, payload) => {
  if (getters.getCurrentDiscussion.id === payload.live_discussion_id) {
    EventBus.$emit('student_nudged', payload.message);
    commit(UPDATE_STUDENT_NUDGE, payload);
  }
};

const SOCKET_NewTurn = ({ commit, getters }, payload) => {
  // TODO: update counter here and check activity log
  let studentDontSpeak = false;
  commit(UPDATE_PARTICIPATION_TURN_COUNT, { payload, studentDontSpeak });
  if (getters.getCurrentDiscussion.audio_discussion_is_enabled) {
    EventBus.$emit('check-user-local-camera', payload.participation_id);
  }
};

const SOCKET_RemoveTurn = ({ commit }, payload) => {
  // TODO: update counter here and check activity log
  let studentDontSpeak = true;
  commit(UPDATE_PARTICIPATION_TURN_COUNT, { payload, studentDontSpeak });
};

const updateLiveDiscussionCircle = ({ commit }, payload) => {
  const { circle_payload } = payload;
  if (typeof payload === 'object' && circle_payload) {
    commit(UPDATE_LIVE_DISCUSSION_CIRCLE, circle_payload);
  } else {
    return getLiveDiscussionCircle(payload)
      .then((res) => {
        commit(UPDATE_LIVE_DISCUSSION_CIRCLE, res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }
};

const updateLiveDiscussionSpread = ({ commit }, payload) => {
  commit(UPDATE_LIVE_DISCUSSION_SPREAD, payload);
};

const addUserToPresenceList = ({ commit }, user_id) => {
  commit('ADD_USER_TO_PRESENCE_LIST', user_id);
};

const removeUserFromPresenceList = ({ commit }, user_id) => {
  commit('REMOVE_USER_FROM_PRESENCE_LIST', user_id);
};

const moderatorChosen = (_, { live_discussion_id, user_id }) => {
  moderatorChosenService(live_discussion_id, user_id).catch(console.error);
};

const SOCKET_moderatorChosen = ({ commit, getters }, user_id) => {
  commit('MODERATOR_CHOSEN', user_id);
  if (getters.getProfile.id === user_id) {
    const toast = {
      type: 'Info',
      message: 'Hey! You are a moderator!',
      time: 5000,
    };
    EventBus.$emit('createToast', toast);
  }
};

const resetModerator = (_, live_discussion_id) => {
  resetModeratorService(live_discussion_id).catch(console.error);
};
const SOCKET_resetModerator = ({ commit }, user) => {
  commit('RESET_MODERATOR', user);
};
const toggleQueue = (_, live_discussion_id) => {
  toggleQueueService(live_discussion_id).catch(console.error);
};
const SOCKET_toggleQueue = ({ commit }, user) => {
  commit('TOGGLE_QUEUE', user);
};

const SOCKET_toggleDiscussionAudio = async (
  { getters, commit },
  liveDiscussion
) => {
  if (
    getters.getCurrentDiscussion.audio_discussion_is_enabled !==
    liveDiscussion.audio_discussion_is_enabled
  ) {
    commit('TOGGLE_DISCUSSION_AUDIO', liveDiscussion);
  }
};

const toggleAudioDiscussion = ({ commit }, liveDiscussionId) => {
  return toggleDiscussionAudio(liveDiscussionId).then((res) => {
    const { data: liveDiscussion } = res;

    if (liveDiscussion) {
      commit('TOGGLE_DISCUSSION_AUDIO', liveDiscussion);
    }

    return liveDiscussion;
  });
};

const endAudioCall = (_, liveDiscussionId) => {
  return endAudioConnection(liveDiscussionId);
};

const SOCKET_endAudioConnection = async ({ commit }) => {
  commit('END_AUDIO_CONNECTION');
  EventBus.$emit('end-live-audio');
  EventBus.$emit('end-participation-audio-live');
};

const SOCKET_discussionExpired = async () => {
  EventBus.$emit('discussion_expired');
};

const SOCKET_toggleParticipationAudio = ({ commit }, participation) => {
  commit('TOGGLE_PARTICIPATION_AUDIO', participation);
  EventBus.$emit('toggle-student-participation-audio', participation);
};

const SOCKET_toggleParticipationVideo = ({ commit }, participation) => {
  commit('TOGGLE_PARTICIPATION_VIDEO', participation);
  EventBus.$emit('toggle-student-participation-video', participation);
};

const SOCKET_muteParticipations = ({ commit }) => {
  commit(MUTE_PARTICIPATIONS);
  EventBus.$emit('mute-participation');
};

const SOCKET_videoOffmuteParticipations = ({ commit }, data) => {
  const { participations_to_update } = data;
  commit(VIDEO_OFF_MUTE_PARTICIPATIONS, participations_to_update);
  /* EventBus.$emit('video-off-mute-participation'); */
};

const selectSavedFeedbackLD = (context, payload) => {
  return liveDiscussionService.selectSavedFeedbackLD(payload.participation_id, {
    feedback_id: payload.feedback_id,
  });
};

const getAgoraRTCConnection = ({ commit }, live_discussion_id) => {
  return liveDiscussionService
    .getAgoraRTCConnection(live_discussion_id)
    .then((res) => {
      if (res.data) {
        commit('START_AUDIO_CONNECTION', res.data);
        return res.data;
      }
    })
    .catch((error) => {
      console.error('getAgoraRTCConnection', error);
      EventBus.$emit(
        'toast-msg',
        'Error connecting to the audio service. Please try again!'
      );
    });
};

const getAgoraRTCConnectionScreen = (_, live_discussion_id) => {
  return liveDiscussionService.getAgoraRTCConnectionScreen(live_discussion_id).then((res) => {
    if (res.data) {
      return res.data;
    }
  });
};

const teacherTapIn = ({ commit }, payload) => {
  commit(TEACHER_TAP_IN, payload);
};

const teacherTapOut = ({ commit }) => {
  commit(TEACHER_TAP_OUT);
};

const syncLDCourseWork = ({ getters, commit }, payload) => {
  return liveDiscussionService
    .syncCourseWork(getters.getCurrentDiscussion.id, payload.courseWorkID)
    .then((data) => {
      const update_keys = {
        google_classroom_course_work_id: payload.courseWorkID,
      };
      commit(UPDATE_LD_DETAILS, update_keys);
      return data;
    });
};

const syncLDAssessmentData = ({ getters }, payload) => {
  return liveDiscussionService
    .syncLDAssessmentData(getters.getCurrentDiscussion.id, payload)
    .then((data) => {
      return data;
    });
};

const openLiveRoundtable = ({ commit }, { id, rtId }) => {
  return liveDiscussionService
    .openParticipation(id)
    .then(() => {
      return commit(MARK_ROUNDTABLE_AS_OPENED, rtId);
    })
    .catch(console.error);
};

export default {
  submitDraftFeedbackForStudent,
  submitFeedbackForStudent,
  addParticipation,
  deleteDiscussion,
  endLiveDiscussion,
  enterLiveDiscussion, // What is the difference between these two
  fetchLiveDiscussion,
  givePoint, // TODO: Deprecate
  loadingLiveDiscussion,
  newTurn,
  pauseLiveDiscussion,
  postClassSummaryLD,
  postFeedbackForStudent,
  updateFeedbackForStudentLD,
  fetchParticipationSummary,
  publishLiveDiscussion, // TODO: Deprecate
  raiseHand,
  removePoint,
  removeStudentLD,
  removeStudentsLD,
  restartLiveDiscussion,
  setDiscussionPauseStatus,
  setLDHasEnded,
  setLDHasRestarted,
  SOCKET_setStartLiveDiscussion,
  updateLiveDiscussion,
  updateParticipation,
  updateParticipationSpread,
  updatePointsSettingsLiveDiscussion,
  updatePrivateTeacherNotes,
  updateStudentNotesLD,
  updateTurn,
  SOCKET_updateQueue,
  autoTurnSpeaker,
  enterQueue,
  leaveQueue,
  tapOut,
  tapIn,
  notSpeakOfQueue,
  promoteStudent,
  turnOffQueue,
  nudgeStudent,
  startLiveDiscussion,
  inviteStudentsToLD,
  saveLiveDiscussionSettings,
  publishStudentNotes,
  SOCKET_ReceiveNudge,
  updateLiveDiscussionCircle,
  SOCKET_NewTurn,
  updateLiveDiscussionSpread,
  addUserToPresenceList,
  removeUserFromPresenceList,
  SOCKET_RemoveTurn,
  moderatorChosen,
  resetModerator,
  SOCKET_moderatorChosen,
  SOCKET_resetModerator,
  toggleQueue,
  SOCKET_toggleQueue,
  updateDraftAssessment,
  updateAssessment,
  selectSavedFeedbackLD,
  updateStudentPointSettings,
  SOCKET_toggleDiscussionAudio,
  SOCKET_toggleParticipationAudio,
  SOCKET_toggleParticipationVideo,
  SOCKET_muteParticipations,
  SOCKET_videoOffmuteParticipations,
  getAgoraRTCConnection,
  getAgoraRTCConnectionScreen,
  teacherTapIn,
  teacherTapOut,
  SOCKET_endAudioConnection,
  toggleAudioDiscussion,
  endAudioCall,
  SOCKET_discussionExpired,
  syncLDCourseWork,
  syncLDAssessmentData,
  openLiveRoundtable,
  getDiscussionTurns,
  getNewAddTurn,
  removeTurn,
  addTurnQueue,
  removeTurnQueue,
  setTurnSpeaker,
  removeTurnSpeaker,
};



// WEBPACK FOOTER //
// ./src/app/store/actions/liveDiscussions.js